module.exports = __webpack_public_path__ + "img/myket.9e5baa7.svg";